import { render, staticRenderFns } from "./Outstandings.vue?vue&type=template&id=f060c892&"
import script from "./Outstandings.vue?vue&type=script&lang=js&"
export * from "./Outstandings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports